import { PageMeta } from 'constants/pages';
import { ArticleSections } from 'types/articles';

import {
  firstSeptember2025NewsData,
  firstSeptember2025NewsMeta,
} from './first-september-2025-news';

interface NewsParameters {
  pageMeta: PageMeta;
  articleData: ArticleSections[];
}

export const NEWS: NewsParameters[] = [
  {
    pageMeta: firstSeptember2025NewsMeta,
    articleData: firstSeptember2025NewsData,
  },
];
